import { useCallback, useEffect } from "react";
import { setUnreadMessages } from "../../../acions/actionsCreators/unreadMessages";
import AuthService from "../../../services/auth";
import { useAppDispatch } from "../../../store";
import { ProfilesService } from "../../../services/profiles";
import { useLocation, Location } from "react-router-dom";
import ROUTES from "../../../configs/routesConfig";
import { useGetRole } from "../../../lib/hooks/getRole";
import { useHasMessagesAccess } from "../../../lib/hooks/useHasMessagesAccess";

export const useHasNotifications = () => {
  const dispatch = useAppDispatch();

  const { canViewMessages } = useHasMessagesAccess();

  const location: Location = useLocation();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, isAdmin] = useGetRole();

  const fetchData = useCallback(async () => {
    try {
      if (AuthService.isLoggedIn() && !isAdmin) {
        const data = await ProfilesService.fetchHasNotifications();

        dispatch(setUnreadMessages(data.hasNotification));
      }
    } catch {}
  }, [dispatch, isAdmin]);

  useEffect(() => {
    let i: any;
    if (location.pathname !== ROUTES.MESSAGES && canViewMessages && !isAdmin) {
      fetchData();
      i = setInterval(fetchData, 15000);
    }

    return () => {
      i && clearInterval(i);
    };
  }, [location, fetchData, isAdmin, canViewMessages]);
};
